import { FortuneWheelButton as FortuneWheelButtonDesktop } from "./ui/fortune-wheel-button.desktop";
import { FortuneWheelButton as FortuneWheelButtonMobile } from "./ui/fortune-wheel-button.mobile";

export const FortuneWheelButton = {
  Desktop: FortuneWheelButtonDesktop,
  Mobile: FortuneWheelButtonMobile,
};
